// extracted by mini-css-extract-plugin
export var bottomCard = "listCards-module--bottomCard--52a82";
export var card = "listCards-module--card--7fd12";
export var category = "listCards-module--category--f0b57";
export var categoryText = "listCards-module--categoryText--58c2f";
export var container = "listCards-module--container--dd8b2";
export var day = "listCards-module--day--5dc60";
export var duration = "listCards-module--duration--378f4";
export var image = "listCards-module--image--b0de9";
export var root = "listCards-module--root--fd02e";
export var titleCard = "listCards-module--titleCard--ee948";